import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  confirm(event) {
    const message = event.target.dataset.confirmMessage

    if (message && !confirm(message)) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }
}
